import type { TooltipDesignTokens } from '@primeuix/themes/types/tooltip';

 export default {
    root: {
        maxWidth: "20rem",
        gutter: "0.25rem",
        shadow: "{overlay.popover.shadow}",
        /* Scaled down with the smaller tooltip type set in primeng-overrides.css. */
        padding: "0.375rem 0.625rem",
        borderRadius: "{overlay.popover.border.radius}"
    },
    colorScheme: {
        light: {
            root: {
                background: "{surface.700}",
                color: "{surface.0}"
            }
        },
        dark: {
            root: {
                background: "{surface.700}",
                color: "{surface.0}"
            }
        }
    }
} satisfies TooltipDesignTokens;